/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';
import { ModulesPlayersApplicationPlayerCareersPlayerCareerResponse } from '../model/modulesPlayersApplicationPlayerCareersPlayerCareerResponse';
import { ModulesPlayersApplicationPlayerSearchPlayerSearchResponse } from '../model/modulesPlayersApplicationPlayerSearchPlayerSearchResponse';
import { ModulesPlayersApplicationPlayerTournamentsPlayerTournamentResponse } from '../model/modulesPlayersApplicationPlayerTournamentsPlayerTournamentResponse';
import { ModulesPlayersApplicationPlayerTypeLinksPlayerTypeLinkResponse } from '../model/modulesPlayersApplicationPlayerTypeLinksPlayerTypeLinkResponse';
import { ModulesPlayersApplicationPlayerTypesPlayerTypeResponse } from '../model/modulesPlayersApplicationPlayerTypesPlayerTypeResponse';
import { ModulesPlayersApplicationPlayersPlayerResponse } from '../model/modulesPlayersApplicationPlayersPlayerResponse';
import { ModulesPlayersEndpointsContractsPlayerTypeLinksCreatePlayerTypeLinkRequestModel } from '../model/modulesPlayersEndpointsContractsPlayerTypeLinksCreatePlayerTypeLinkRequestModel';
import { ModulesPlayersEndpointsContractsPlayersCreatePlayerRequest } from '../model/modulesPlayersEndpointsContractsPlayersCreatePlayerRequest';
import { ModulesPlayersEndpointsContractsPlayersUpdatePlayerRequestModel } from '../model/modulesPlayersEndpointsContractsPlayersUpdatePlayerRequestModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { PlayersServiceInterface }                            from './players.serviceInterface';


@Injectable()
export class PlayersService implements PlayersServiceInterface {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Gets a Player.
     * Gets a Player using the Player identifier.
     * @param playerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayerByIdEndpoint(playerId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesPlayersApplicationPlayersPlayerResponse>;
    public getPlayerByIdEndpoint(playerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesPlayersApplicationPlayersPlayerResponse>>;
    public getPlayerByIdEndpoint(playerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesPlayersApplicationPlayersPlayerResponse>>;
    public getPlayerByIdEndpoint(playerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playerId === null || playerId === undefined) {
            throw new Error('Required parameter playerId was null or undefined when calling getPlayerByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesPlayersApplicationPlayersPlayerResponse>('get',`${this.basePath}/players/${encodeURIComponent(String(playerId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Player career summary.
     * Gets a Player career summary using the Player identifier.
     * @param playerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayerCareerEndpoint(playerId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesPlayersApplicationPlayerCareersPlayerCareerResponse>;
    public getPlayerCareerEndpoint(playerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesPlayersApplicationPlayerCareersPlayerCareerResponse>>;
    public getPlayerCareerEndpoint(playerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesPlayersApplicationPlayerCareersPlayerCareerResponse>>;
    public getPlayerCareerEndpoint(playerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playerId === null || playerId === undefined) {
            throw new Error('Required parameter playerId was null or undefined when calling getPlayerCareerEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesPlayersApplicationPlayerCareersPlayerCareerResponse>('get',`${this.basePath}/players/${encodeURIComponent(String(playerId))}/career`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Player tournament scorecard.
     * Gets a Player tournament scorecard using the Player and Tournament identifiers.
     * @param playerId 
     * @param tournamentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayerTournamentEndpoint(playerId: string, tournamentId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesPlayersApplicationPlayerTournamentsPlayerTournamentResponse>;
    public getPlayerTournamentEndpoint(playerId: string, tournamentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesPlayersApplicationPlayerTournamentsPlayerTournamentResponse>>;
    public getPlayerTournamentEndpoint(playerId: string, tournamentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesPlayersApplicationPlayerTournamentsPlayerTournamentResponse>>;
    public getPlayerTournamentEndpoint(playerId: string, tournamentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playerId === null || playerId === undefined) {
            throw new Error('Required parameter playerId was null or undefined when calling getPlayerTournamentEndpoint.');
        }

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getPlayerTournamentEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesPlayersApplicationPlayerTournamentsPlayerTournamentResponse>('get',`${this.basePath}/players/${encodeURIComponent(String(playerId))}/tournaments/${encodeURIComponent(String(tournamentId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a PlayerTypeLink by LinkId.
     * Gets a PlayerTypeLink using the LinkId.
     * @param linkId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayerTypeLinkByIdEndpoint(linkId: number, observe?: 'body', reportProgress?: boolean): Observable<ModulesPlayersApplicationPlayerTypeLinksPlayerTypeLinkResponse>;
    public getPlayerTypeLinkByIdEndpoint(linkId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesPlayersApplicationPlayerTypeLinksPlayerTypeLinkResponse>>;
    public getPlayerTypeLinkByIdEndpoint(linkId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesPlayersApplicationPlayerTypeLinksPlayerTypeLinkResponse>>;
    public getPlayerTypeLinkByIdEndpoint(linkId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (linkId === null || linkId === undefined) {
            throw new Error('Required parameter linkId was null or undefined when calling getPlayerTypeLinkByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesPlayersApplicationPlayerTypeLinksPlayerTypeLinkResponse>('get',`${this.basePath}/players/types/${encodeURIComponent(String(linkId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets PlayerTypes by Player identifier.
     * Gets PlayerTypes by Player identifier.
     * @param playerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayerTypesByIdEndpoint(playerId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesPlayersApplicationPlayerTypesPlayerTypeResponse>>;
    public getPlayerTypesByIdEndpoint(playerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesPlayersApplicationPlayerTypesPlayerTypeResponse>>>;
    public getPlayerTypesByIdEndpoint(playerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesPlayersApplicationPlayerTypesPlayerTypeResponse>>>;
    public getPlayerTypesByIdEndpoint(playerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playerId === null || playerId === undefined) {
            throw new Error('Required parameter playerId was null or undefined when calling getPlayerTypesByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesPlayersApplicationPlayerTypesPlayerTypeResponse>>('get',`${this.basePath}/players/${encodeURIComponent(String(playerId))}/types`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a list of PlayerTypes.
     * Retrieves all available PlayerTypes.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayerTypesEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesPlayersApplicationPlayerTypesPlayerTypeResponse>>;
    public getPlayerTypesEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesPlayersApplicationPlayerTypesPlayerTypeResponse>>>;
    public getPlayerTypesEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesPlayersApplicationPlayerTypesPlayerTypeResponse>>>;
    public getPlayerTypesEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesPlayersApplicationPlayerTypesPlayerTypeResponse>>('get',`${this.basePath}/players/playerTypes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all Players.
     * Gets all Players.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayersEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesPlayersApplicationPlayersPlayerResponse>>;
    public getPlayersEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesPlayersApplicationPlayersPlayerResponse>>>;
    public getPlayersEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesPlayersApplicationPlayersPlayerResponse>>>;
    public getPlayersEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesPlayersApplicationPlayersPlayerResponse>>('get',`${this.basePath}/players`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a Player.
     * Removes a Player using the Player identifier.
     * @param playerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playersPlayerIdDelete(playerId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public playersPlayerIdDelete(playerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public playersPlayerIdDelete(playerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public playersPlayerIdDelete(playerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playerId === null || playerId === undefined) {
            throw new Error('Required parameter playerId was null or undefined when calling playersPlayerIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/players/${encodeURIComponent(String(playerId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a Player.
     * Updates a Player based on the Player identifer and UpdatePlayerRequest.
     * @param playerId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playersPlayerIdPut(playerId: string, body?: ModulesPlayersEndpointsContractsPlayersUpdatePlayerRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public playersPlayerIdPut(playerId: string, body?: ModulesPlayersEndpointsContractsPlayersUpdatePlayerRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public playersPlayerIdPut(playerId: string, body?: ModulesPlayersEndpointsContractsPlayersUpdatePlayerRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public playersPlayerIdPut(playerId: string, body?: ModulesPlayersEndpointsContractsPlayersUpdatePlayerRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playerId === null || playerId === undefined) {
            throw new Error('Required parameter playerId was null or undefined when calling playersPlayerIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/players/${encodeURIComponent(String(playerId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a PlayerTypeLink.
     * Creates a PlayerTypeLink based on the CreatePlayerTypeLinkRequest request.
     * @param playerId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playersPlayerIdTypesPost(playerId: string, body?: ModulesPlayersEndpointsContractsPlayerTypeLinksCreatePlayerTypeLinkRequestModel, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public playersPlayerIdTypesPost(playerId: string, body?: ModulesPlayersEndpointsContractsPlayerTypeLinksCreatePlayerTypeLinkRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public playersPlayerIdTypesPost(playerId: string, body?: ModulesPlayersEndpointsContractsPlayerTypeLinksCreatePlayerTypeLinkRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public playersPlayerIdTypesPost(playerId: string, body?: ModulesPlayersEndpointsContractsPlayerTypeLinksCreatePlayerTypeLinkRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playerId === null || playerId === undefined) {
            throw new Error('Required parameter playerId was null or undefined when calling playersPlayerIdTypesPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/players/${encodeURIComponent(String(playerId))}/types`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a Player.
     * Creates a Player based on the CreatePlayerRequest request.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playersPost(body?: ModulesPlayersEndpointsContractsPlayersCreatePlayerRequest, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public playersPost(body?: ModulesPlayersEndpointsContractsPlayersCreatePlayerRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public playersPost(body?: ModulesPlayersEndpointsContractsPlayersCreatePlayerRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public playersPost(body?: ModulesPlayersEndpointsContractsPlayersCreatePlayerRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/players`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Searches Players.
     * Searches Players by first or last name.
     * @param q 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchPlayersEndpoint(q?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesPlayersApplicationPlayerSearchPlayerSearchResponse>>;
    public searchPlayersEndpoint(q?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesPlayersApplicationPlayerSearchPlayerSearchResponse>>>;
    public searchPlayersEndpoint(q?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesPlayersApplicationPlayerSearchPlayerSearchResponse>>>;
    public searchPlayersEndpoint(q?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (q !== undefined && q !== null) {
            queryParameters = queryParameters.set('q', <any>q);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesPlayersApplicationPlayerSearchPlayerSearchResponse>>('get',`${this.basePath}/players/search`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
